import { render } from "./downloadgraduateform.vue?vue&type=template&id=ed500870&scoped=true"
import script from "./downloadgraduateform.vue?vue&type=script&lang=js"
export * from "./downloadgraduateform.vue?vue&type=script&lang=js"

import "./downloadgraduateform.vue?vue&type=style&index=0&id=ed500870&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\GCTUSMS\\codev1\\apply_online\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed500870"]])

export default __exports__